import { hasCapability, type User } from "../base";

export const bidScoring = {
  read: (user: User) => hasCapability(user, "bidScoring.read"),
};
